var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-compoment"},[_c('van-nav-bar',{staticClass:"nav",attrs:{"title":_vm.title,"left-text":_vm.leftText,"left-arrow":_vm.leftArrow},on:{"click-left":_vm.onClickLeft},scopedSlots:_vm._u([{key:"right",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-185bf1e4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar/index.vue
// module id = null
// module chunks = 